import { Injectable } from "@angular/core";
import { IBusiness } from "src/app/metadata/interfaces/page/Pages";

interface TemplateManagementModel {
  ID: string;
  data: {
    folder: string;
    titlePrefix: string;
    buttonText: string;
  };
}

interface FinalData {
  imgLink: string;
  title: string;
  buttonText: string;
}

const linkPrefixHotel: string =
  "../../../../assets/images/bg-images/defaults/hotel/";

const linkPrefixCityGuide: string =
  "../../../../assets/images/bg-images/defaults/city-guide/";

export const templateManagementDataHotel: TemplateManagementModel[] = [
  {
    ID: "business-module-1000",
    data: {
      folder: "in-house",
      titlePrefix: "In House",
      buttonText: "BOOK NOW",
    },
  },
  {
    ID: "business-module-10000",
    data: {
      folder: "room-and-suites",
      titlePrefix: "Rooms & Suites",
      buttonText: "BOOK NOW",
    },
  },
  {
    ID: "business-module-100000",
    data: {
      folder: "restaurant",
      titlePrefix: "Restaurant",
      buttonText: "PLACE AN ORDER",
    },
  },
  {
    ID: "business-module-2000",
    data: {
      folder: "room-services",
      titlePrefix: "Room Services",
      buttonText: "REQUEST SERVICE",
    },
  },
  {
    ID: "business-module-20000",
    data: {
      folder: "bar",
      titlePrefix: "Bar",
      buttonText: "PLACE AN ORDER",
    },
  },
  {
    ID: "business-module-200000",
    data: {
      folder: "fitness",
      titlePrefix: "Fitness Center",
      buttonText: "ADD TO SCHEDULE",
    },
  },
  {
    ID: "business-module-2000000",
    data: {
      folder: "spa",
      titlePrefix: "Spa",
      buttonText: "SCHEDULE APPOINTMENT",
    },
  },
];

export const templateManagementDataCityGuide: TemplateManagementModel[] = [
  {
    ID: "guide-module-1000",
    data: {
      folder: "shopping",
      titlePrefix: "Shopping Area",
      buttonText: "VISIT US",
    },
  },
  {
    ID: "guide-module-10000",
    data: {
      folder: "restaurants",
      titlePrefix: "Restaurants",
      buttonText: "PLACE AN ORDER",
    },
  },
  {
    ID: "guide-module-100000",
    data: {
      folder: "night-life",
      titlePrefix: "Night Life",
      buttonText: "EXPLORE",
    },
  },
  {
    ID: "guide-module-2000",
    data: {
      folder: "kids-zone",
      titlePrefix: "Kids Zone",
      buttonText: "EXPLORE",
    },
  },
  {
    ID: "guide-module-20000",
    data: {
      folder: "neighborhood",
      titlePrefix: "Neighborhood",
      buttonText: "EXPLORE",
    },
  },
  {
    ID: "guide-module-200000",
    data: {
      folder: "must-know",
      titlePrefix: "Must Know",
      buttonText: "EXPLORE",
    },
  },
  {
    ID: "guide-module-2000000",
    data: {
      folder: "mechandises",
      titlePrefix: "Mechandises",
      buttonText: "PLACE AN ORDER",
    },
  },
];

@Injectable({
  providedIn: "root",
})
export class TemplateManagementService {
  constructor() {}

  private getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }

  private imageIndex(itemCount: number): number {
    return ~~this.getRandomArbitrary(4, 7);
  }

  handleManagement(
    IsHotelModule: boolean,
    ModuleID: string,
    Businesses: IBusiness
  ): FinalData {
    let finalData: FinalData;
    if (IsHotelModule) {
      let ModuleIndex = Businesses.Hotel.findIndex(
        (s) => s.ItemModule.ID == ModuleID
      );
      let index;
      templateManagementDataHotel.forEach((element) => {
        if (element.ID == ModuleID) {
          let numberOfItems = Businesses.Hotel[ModuleIndex].Itemlist.length;
          if (numberOfItems < 6) {
            index = numberOfItems + 1;
          } else {
            index = this.imageIndex(numberOfItems);
          }
          let imgLink =
            linkPrefixHotel + element.data.folder + "/bg" + index + ".jpg";
          let title = element.data.titlePrefix + " " + (numberOfItems + 1);
          let buttonText = element.data.buttonText;

          finalData = {
            buttonText: buttonText,
            imgLink: imgLink,
            title: title,
          };
        } else {
        }
      });
    } else {
      let ModuleIndex = Businesses.CityGuide.findIndex(
        (s) => s.ItemModule.ID == ModuleID
      );
      let index;
      templateManagementDataCityGuide.forEach((element) => {
        if (element.ID == ModuleID) {
          let numberOfItems = Businesses.CityGuide[ModuleIndex].Itemlist.length;
          if (numberOfItems <= 6) {
            index = numberOfItems + 1;
          } else {
            index = this.imageIndex(numberOfItems);
          }
          let imgLink =
            linkPrefixCityGuide + element.data.folder + "/bg" + index + ".jpg";
          let title = element.data.titlePrefix + " " + (numberOfItems + 1);
          let buttonText = element.data.buttonText;

          finalData = {
            buttonText: buttonText,
            imgLink: imgLink,
            title: title,
          };
        } else {
        }
      });
    }

    return finalData;
  }
}
